import React from "react";
import { Box } from "./AHTheme/Box";

export function ListItemGroup(props: { children?: React.ReactNode }) {
  return <Box spaceBottom="medium">{props.children}</Box>;
}
